import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

import store from './store';

import Modal from './components/modal.vue';

import components from './components';
import helpers from './helpers';
import plugins from './plugins';

plugins.init();

Vue.component('Modal', Modal);

new Vue({ // eslint-disable-line
    el: '#app',
    components,
    data() {
        return {
            showMenu: false,
            showMiniCart: false,
            showWooCommerceMessage: false,
            timeoutWooCommerceMessage: null,
        };
    },
    mounted() {
        helpers.init();

        this.showMinicartOnATC();
    },
    computed: {
        ...mapState('modal', ['modal', 'currentSliderIndex']),
    },
    methods: {
        ...mapMutations('modal', ['setModal']),

        trackButtonClick(name, type, options) {
            if (typeof window.fbq === 'function') {
                window.fbq(name, type, options);
            }
        },

        showMinicartOnATC() {
            const addToCartButton = document.querySelectorAll([
                '.ajax_add_to_cart',
                '.single_add_to_cart_button',
            ]);

            addToCartButton.forEach((button) => {
                button.addEventListener('click', (e) => {
                    const target = e.currentTarget;

                    clearTimeout(this.timeoutWooCommerceMessage);

                    const addedToCart = setInterval(() => {
                        if (target.classList.contains('added')) {
                            if (window.screen.width > 720) {
                                this.showMiniCart = true;
                                window.scrollTo(0, 0);
                            }

                            this.showWooCommerceMessage = true;

                            this.timeoutWooCommerceMessage = setTimeout(() => {
                                this.showWooCommerceMessage = false;
                            }, 2000);

                            clearInterval(addedToCart);
                        }
                    }, 100);
                });
            });
        },
    },
    store,
});
